import { Modal } from 'antd';
import { CenterPopup, Ellipsis, Image, Popover, Popup, SpinLoading, Toast } from 'antd-mobile';
import { GlobalLoadingContext, useThrottledHandler } from 'App';
import img from 'app/img';
import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import { backgroundImage } from 'html2canvas/dist/types/css/property-descriptors/background-image';
import { useContext, useEffect, useRef, useState } from 'react';
import { AiFillCloseCircle, AiFillFileText, AiOutlineUpload } from 'react-icons/ai';
import CypherApi from 'services/apis/cnt2/cypher-api';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { postSourceTypeMap } from 'services/gather_bo/_total';
import { copy2Clipboard } from 'utils/clipboardUtil';
import { downloadImageStrong } from 'utils/downloadUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';

export type ShareCypherDT = {
  cypher: String;
  postId: string;
  postTitle: string;
  postCover: string;
  postSourceType: string;
};
// const mimeShareCypher = useRef<ShareCypherDT>(null);

const ShareCypher = (data: {
  mimeShareCypher: ShareCypherDT;
  showShareModal: boolean;
  setShowShareModal: (showShareModal: boolean) => void;
}) => {
  const userPolyInfo = getItemWithExpiration('userPolyInfo') as UserPolyInfoDT;
  const showGlobalLoading = useContext(GlobalLoadingContext).showGlobalLoading;
  const globalLoading = useContext(GlobalLoadingContext).globalLoading;

  const [showLoadingMask, setShowLoadingMask] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const [mimeShareCypher, setMimeShareCypher] = useState<ShareCypherDT>(null);

  const shareCypher = async (_data: ShareCypherDT) => {
    // const fingerprint: string = (await getBrowserFinger()).fingerprint;
    const resp = await CypherApi.shareCypher({}, { fkUserId: userPolyInfo.asUser.uuid, fkPostId: _data.postId });
    if (!resp.successful) {
      Toast.show(resp.msg);
    }
    const cypher = resp.result;
    setMimeShareCypher({ ..._data, cypher });

    // 自动导出会有些问题
    // if (data?.showShareModal) {
    //   copy2Clipboard(cypher);
    //   Toast.show('已复制到剪贴板');
    // }
  };

  useEffect(() => {
    if (data.mimeShareCypher) {
      shareCypher(data.mimeShareCypher);
    }

    setShowShareModal(data.showShareModal);
  }, [data]);

  return (
    <>
      {/* 前面的优先级更低 */}
      {/* 模态框：口令海报 */}
      <CenterPopup
        visible={showShareModal}
        closeOnMaskClick={true}
        showCloseButton={false}
        onClose={() => {
          setShowShareModal(false);
          data.setShowShareModal(false);
        }}
        style={{ '--background-color': 'transparent' }}
        onClick={() => {
          setShowShareModal(false);
          data.setShowShareModal(false);
        }}
      >
        {/* 海报内容 */}
        <center
          className=" scale-75 origin-bottom-left -mt-32"
          onClick={() => {
            setShowShareModal(false);
            data.setShowShareModal(false);
          }}
        >
          {/* 海报 */}
          <div
            id="cypherModalCanvas"
            className=" flex flex-col justify-center items-center w-full px-2 bg-gradient-to-br from-violet-100 to-fuchsia-200 shadow-2xl"
            style={{
              borderRadius: 30,
              border: '2px solid #666',
              background: 'url(' + img.poster_opt2 + ') center center / cover no-repeat',
              position: 'relative',
              width: window.innerWidth,
              height: window.innerWidth * 1.8,
              // transform: 'scale(2)',
              // marginLeft: window.innerWidth * 2,
              // marginTop: window.innerWidth * 1,
            }}
          >
            <div
              className=" text-base p-3 pt-5 bg-gradient-to-b from-white/100 to-white/100 rounded-3xl shadow-xl"
              style={{ marginTop: window.innerWidth * 0.62 }}
            >
              {/* 主体信息 */}
              <div className={[' flex flex-col justify-center items-center c relative text-white '].join(' ')}>
                {/* 图片 */}
                {true && (
                  <div
                    style={{
                      // 草淡了，属性分开写不行，合一起又有用
                      background: `url('${mimeShareCypher?.postCover}') center center / cover no-repeat`,
                      width: window.innerWidth * 0.6,
                      // minWidth: 150,
                      aspectRatio: '1/1',
                      borderRadius: '100%',
                      overflow: 'hidden',
                      filter: 'blur(3px) brightness(0.75)',
                    }}
                    // html2canvas 无法捕捉到CSS滤镜效果（如blur、grayscale等）
                    // 在这个库中，他们使用了 foreign-object，而foreign-object 不支持 BACKGROUND-filter
                    className=" relative flex justify-center items-center "
                  />
                )}
                {/* 信息 */}
                {true && (
                  <center
                    style={{ width: window.innerWidth * 0.6, aspectRatio: '1/1', borderRadius: '100%' }}
                    className=" text-base border border-white absolute top-0 overflow-hidden"
                  >
                    {/* 二维码+提示 */}
                    <div className=" p-4 h-full w-full flex justify-around items-center text-slate-100 ">
                      <Image
                        src={img.qrcodeUUTT}
                        width={90}
                      />
                      <center className=" py-2 font-bold text-base">
                        <div className=" shadow-md rounded-md bg-black/60 px-2 py-1.5 m-1">领取资源</div>
                        <div className=" ">
                          <div>1.扫码下载</div>
                          <div>2.输入口令</div>
                        </div>
                      </center>
                    </div>
                    {/* 标签 */}
                    <div className=" text-sm absolute top-0 p-2 w-full rounded-md bg-slate-500 bg-opacity-70 shadow-md text-center">
                      {postSourceTypeMap.get(mimeShareCypher?.postSourceType)}
                    </div>
                  </center>
                )}
                {/* 口令 */}
                <div
                  className=" text-xl absolute bottom-0 py-2 pl-4 pr-2 bg-gradient-to-b bg-slate-500 from-slate-500/70 from-0% via-slate-500/100 via-50% to-slate-500/70 to-100% rounded-md shadow-md text-slate-50 tracking-[10px] text-center font-mono"
                  style={{ width: window.innerWidth * 0.6 }}
                >
                  {mimeShareCypher?.cypher}
                </div>
              </div>
              {/* 底部文字 */}
              {true && (
                <div>
                  <div
                    className=" mx-8 mt-6 text-nowrap text-center"
                    style={{ width: window.innerWidth * 0.6, overflow: 'hidden' }}
                  >
                    {'真正的英雄 ● ' + userPolyInfo.asUser.username}
                  </div>
                  <center
                    className=" text-sm m-2 font-bold text-nowrap whitespace-nowrap underline underline-offset-4 text-orange-500"
                    onClick={() => {
                      window.open('https://uutt.me');
                    }}
                  >
                    『UU天堂』UUTT.ME
                  </center>
                </div>
              )}
            </div>
          </div>
        </center>
        {/* 点击按钮 */}
        <div className=" my-4 py-2 flex justify-around items-center text-nowrap shadow-md rounded-md bg-white/50 w-full">
          {/* 复制口令 */}
          <div
            className=" flex justify-center items-center gap-2 rounded-md shadow-md p-3 bg-gradient-to-br from-slate-400 to-slate-500 text-white"
            onClick={useThrottledHandler(() => {
              const st = `代号3A6F特别行动中，我方击败1D72号生化个体，获得4F级圣遗物。`;
              const cypher = getCypher(mimeShareCypher.cypher);
              copy2Clipboard(cypher);
              Toast.show('已复制到剪贴板');
            })}
          >
            <AiFillFileText
              size={20}
              className=" inline-block mb-0.5"
            />
            <div className=" ">复制口令</div>
          </div>

          <div>
            <AiFillCloseCircle
              size={30}
              color="white"
              onClick={() => {
                setShowShareModal(false);
                data.setShowShareModal(false);
              }}
            />
          </div>

          {/* 导出海报 */}
          <div
            className=" flex justify-center items-center gap-2 rounded-md shadow-md p-3 bg-gradient-to-br from-orange-400 to-orange-500 text-white"
            onClick={useThrottledHandler(() => {
              if (showLoadingMask) {
                return;
              }
              if (globalLoading) {
                return;
              }
              showGlobalLoading({ timeout: 5000 });

              // 显示遮罩
              // setShowLoadingMask(true);

              // 获取元素
              const element = document.getElementById('cypherModalCanvas');

              /*
              html2canvas库对以下样式可能无效或不完全支持：
              CSS动画和过渡效果：html2canvas库在截图时不会触发CSS动画和过渡效果，只会捕捉到元素的初始状态。
              CSS伪元素（如::before和::after）：html2canvas库无法捕捉到CSS伪元素的样式。
              CSS滤镜效果：html2canvas库无法捕捉到CSS滤镜效果（如blur、grayscale等）。
              CSS变量（CustomProperties）：html2canvas库无法解析和应用CSS变量。
              SVG图像：html2canvas库对SVG图像的支持有限，可能无法正确渲染和捕捉SVG图像。
            */
              // html2canvas(element, {
              //   useCORS: true, // 允许跨域资源
              //   allowTaint: true, // 允许加载外部资源
              //   backgroundColor: null, // 设置为透明
              //   scale: 0.95, // 渲染比例
              // }).then((canvas) => {
              //   // 将生成的 canvas 转换为图片
              //   const imageUrl = canvas.toDataURL('image/png');
              //   console.log('imageUrl', imageUrl);

              //   // 创建一个链接并下载图片
              //   const link = document.createElement('a');
              //   link.href = imageUrl;
              //   link.download = '【UU天堂-UUTT.ME】' + mimeShareCypher?.cypher + '.png';
              //   link.click();

              //   setTimeout(() => {
              //     Toast.show('已导出到本地相册');
              //     setShowLoadingMask(false);
              //   }, 1500);
              // });

              const contentHeight = element.clientHeight; // 实际图片根据canvas转化，根据内容会变
              const contentWidth = element.clientWidth;
              const scale = 4;

              domtoimage
                .toPng(element, {
                  // cacheBust: 1,
                  // height: contentHeight * scale,
                  // width: contentWidth * scale,
                  scale: 1,
                  // quality: 1, // 1 是最高质量
                  // style: {
                  //   transform: `scale(${scale})`, // 指定缩放比例
                  //   transformOrigin: 'center center', // 指定缩放基点
                  //   background: `url('${img.poster_opt2}') center center / cover no-repeat`,
                  // },
                })
                .then((imageUrl) => {
                  // console.log('domtoimage-dataUrl', imageUrl);

                  const imageName = '【UU天堂-UUTT.ME】' + mimeShareCypher?.cypher + '.png';
                  downloadImageStrong({ imageUrl, imageName });
                });
            })}
          >
            <AiOutlineUpload
              size={20}
              className=" inline-block mb-0.5"
            />
            <div className=" ">导出海报</div>
          </div>
        </div>
      </CenterPopup>
    </>
  );
};

export default ShareCypher;

export const getCypher = (cypherKey: String) => {
  const s1 = cypherKey.substring(0, 4);
  const s2 = cypherKey.substring(4, 8);
  const s3 = cypherKey.substring(8, 10);
  const ss = `代号${s1}特别行动中，我方击败${s2}号生化个体，获得${s3}级圣遗物。`;
  return ss;
};
